
const m = window.require("@ember/object/mixin");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
